// Helpers purs pour fusionner les 3 sources d'emplacements (pistes réelles,
// remontées réelles, emplacements personnalisés) en une seule liste taguée, et
// pour résoudre le location_type métier d'un élément. Extrait de useLocations
// pour être testable sans rendre le hook.

/**
 * Tague un emplacement avec sa table d'origine, pour distinguer une vraie
 * piste/remontée d'un emplacement personnalisé même une fois dans la même liste.
 * @param {Object} item
 * @param {'slope'|'lift'|'custom'} kind
 * @returns {Object}
 */
export const tagLocation = (item, kind) => ({
  ...item,
  __kind: kind,
  isCustom: kind === 'custom',
})

/**
 * Construit la liste taguée affichée pour l'onglet actif.
 * - slope  : pistes réelles + customs de type 'slope'
 * - lift   : remontées réelles + customs de type 'lift'
 * - custom : customs qui ne sont ni slope ni lift
 * Les customs sont TOUJOURS tagués __kind:'custom' (isCustom:true), quel que
 * soit l'onglet — c'est ce qui les rend supprimables partout.
 * @param {{locationType: string, slopes?: Array, lifts?: Array, customLocations?: Array}} params
 * @returns {Array}
 */
export const buildLocationsByType = ({
  locationType,
  slopes = [],
  lifts = [],
  customLocations = [],
}) => {
  if (locationType === 'slope') {
    const customSlopes = customLocations.filter(
      cl => cl.location_type === 'slope',
    )
    return [
      ...slopes.map(s => tagLocation(s, 'slope')),
      ...customSlopes.map(c => tagLocation(c, 'custom')),
    ]
  }
  if (locationType === 'lift') {
    const customLifts = customLocations.filter(
      cl => cl.location_type === 'lift',
    )
    return [
      ...lifts.map(l => tagLocation(l, 'lift')),
      ...customLifts.map(c => tagLocation(c, 'custom')),
    ]
  }
  if (locationType === 'custom') {
    return customLocations
      .filter(cl => cl.location_type !== 'slope' && cl.location_type !== 'lift')
      .map(c => tagLocation(c, 'custom'))
  }
  return []
}

/**
 * Renvoie l'emplacement avec un location_type corrigé pour la construction du
 * payload de tâche, basé sur la table d'origine (__kind) et non sur l'onglet UI.
 * - remontée réelle -> location_type:'lift' (les lifts réels n'ont pas de type)
 * - piste réelle    -> location_type:null   (determineLocationType -> 'slope')
 * - custom          -> inchangé             (garde area/building/lift/slope/other)
 * Null-safe (le chemin de désélection passe null).
 * @param {Object|null} location
 * @returns {Object|null}
 */
export const withResolvedLocationType = location => {
  if (!location) return location
  if (location.__kind === 'lift') return { ...location, location_type: 'lift' }
  if (location.__kind === 'slope') return { ...location, location_type: null }
  return location
}
